/**
 * prefix  api
 * method  Get | Post | Put | Delete
 * service name
 * action  name
 * examplePath  api-Get-Document-GetIncomingDocuments  // Document/Documents/GetIncomingDocuments
 */
const ApiUrl = {
  // Agreement/Agreements
  apiGetAgreementGetAgreement: "Agreement/Agreements/GetAgreement",
  apiGetAgreementGetAgreementsByEntityId: "Agreement/Agreements/GetAgreementsByEntityId",
  apiGetAgreementGetAgreementsOfLeadersFilters: "Agreement/Agreements/GetAgreementsOfLeadersFilters",
  apiGetAgreementGetAgreementStatusBlock: "Agreement/Agreements/GetAgreementStatusBlock",
  apiPostAgreementDeleteAgreement: "Agreement/Agreements/DeleteAgreement",
  apiPostAgreementSaveAgreement: "Agreement/Agreements/SaveAgreement",

  // Agreement/AgreementTemplates
  apiGetAgreementGetAgreementTemplate: "Agreement/AgreementTemplates/GetAgreementTemplate",
  apiGetAgreementGetAgreementTemplates: "Agreement/AgreementTemplates/GetAgreementTemplates",
  apiPostAgreementDeleteAgreementTemplate: "Agreement/AgreementTemplates/DeleteAgreementTemplate",
  apiPostAgreementSaveAgreementTemplate: "Agreement/AgreementTemplates/SaveAgreementTemplate",

  // Dictionary/DictionaryItem
  apiGetDictionaryByTextWithFilter: "Dictionary/DictionaryItem/GetDictionaryItemsByTextWithFilter",
  apiGetDictionaryGetAllDictionaryItemsByDictionaryIdentifier: "Dictionary/DictionaryItem/GetAllDictionaryItemsByDictionaryIdentifier",
  apiGetDictionaryGetAllDictionaryItemsByDictionaryIdentifierWithPagination:
    "Dictionary/DictionaryItem/GetAllDictionaryItemsByDictionaryIdentifierWithPagination",
  apiGetDictionaryGetDictionaryItemByDictionaryItemIdentifier: "Dictionary/DictionaryItem/GetDictionaryItemByDictionaryItemIdentifier",
  apiGetDictionaryGetDictionaryItemById: "Dictionary/DictionaryItem/GetDictionaryItemById",
  apiGetDictionaryGetDictionaryItemByIdentifier: "Dictionary/DictionaryItem/GetDictionaryItemByIdentifier",
  apiGetDictionaryGetDictionaryItemIdentifiersByDictionaryIdentifier: "Dictionary/DictionaryItem/GetDictionaryItemIdentifiersByDictionaryIdentifier",
  apiGetDictionaryGetDictionaryItems: "Dictionary/DictionaryItem/GetDictionaryItems",
  apiGetDictionaryGetDictionaryItemsByDictionaryIdentifier: "Dictionary/DictionaryItem/GetDictionaryItemsByDictionaryIdentifier",
  apiGetDictionaryGetDictionaryItemsByParentIdOrIdentifier: "Dictionary/DictionaryItem/GetDictionaryItemsByParentIdOrIdentifier",
  apiGetDictionaryGetDictionaryItemsWithTranslationsByDictionaryIdentifier:
    "Dictionary/DictionaryItem/GetDictionaryItemsWithTranslationsByDictionaryIdentifier",
  apiGetDictionaryGetDictionaryItemTranslationName: "Dictionary/DictionaryItem/GetDictionaryItemTranslationName",
  apiGetDictionaryGetDocumentLanguagesWithTranslations: "Dictionary/DictionaryItem/GetDocumentLanguagesWithTranslations",
  apiGetDictionaryItemsGetDocumentLanguages: "Dictionary/DictionaryItem/GetDocumentLanguages",
  apiGetDictionaryUpdateDictionaryItemSequence: "Dictionary/DictionaryItem/UpdateDictionaryItemSequence",
  apiPostDictionaryAddDictionaryItem: "Dictionary/DictionaryItem/AddDictionaryItem",
  apiPostDictionaryDeleteDictionaryItem: "Dictionary/DictionaryItem/DeleteDictionaryItem",
  apiPostDictionaryGetDictionaryItemsById: "Dictionary/DictionaryItem/GetDictionaryItemsById",
  apiPostDictionaryItemUpdateDictionaryItemSequence: "Dictionary/DictionaryItem/UpdateDictionaryItemSequence",
  apiPostDictionaryUpdateDictionaryItem: "Dictionary/DictionaryItem/UpdateDictionaryItem",
  apiPostUpdateDictionaryItemEntityState: "Dictionary/DictionaryItem/UpdateDictionaryItemEntityState",

  // Dictionary/DictionaryRelation
  apiGetDictionaryGetAllDictionaryRelation: "Dictionary/DictionaryRelation/GetAllDictionaryRelation",
  apiGetDictionaryRelationAddDictionaryRelation: "Dictionary/DictionaryRelation/AddDictionaryRelation",
  apiGetDictionaryRelationDeleteDictionaryRelation: "Dictionary/DictionaryRelation/DeleteDictionaryRelation",
  apiGetDictionaryRelationGetDictionaries: "Dictionary/DictionaryRelation/GetDictionaries",
  apiGetDictionaryRelationGetEntitiesByDictionaryId: "Dictionary/DictionaryRelation/GetEntitiesByDictionaryId",
  apiGetDictionaryRelationGetRelatedDictionaries: "Dictionary/DictionaryRelation/GetRelatedDictionaries",

  // Dictionary/Dictionary
  apiGetDictionaryGetDictionaryGroupItems: "Dictionary/Dictionary/GetDictionaryGroupItems",
  apiGetDictionaryGetDictionaryIdentifiers: "/Dictionary/Dictionary/GetDictionaryIdentifiers",
  apiGetDictionaryGetAllDictionaries: "Dictionary/Dictionary/GetAllDictionaries",
  apiPostDictionaryAddDictionary: "Dictionary/Dictionary/AddDictionary",
  apiPostDictionaryDeleteDictionary: "Dictionary/Dictionary/DeleteDictionary",
  apiPostDictionaryUpdateDictionary: "Dictionary/Dictionary/UpdateDictionary",

  // Document/Converters
  apiGetDocumentGetAgreementFile: "Document/Converters/GetAgreementFile",

  // Document/Setups
  apiPostDocumentDeleteDocument: "Document/Setups/DeleteDocument",
  apiPostDocumentDeleteResolution: "Document/Setups/DeleteResolution",
  apiPostDocumentGenerateResolutionFile: "Document/Setups/GenerateResolutionFile",

  // Nomenclature/Cases
  apiGetDocumentCasesGetDocument: "Nomenclature/Cases/GetDocument",
  apiGetDocumentCheckStaffHasAccessForDocumentInCase: "Nomenclature/Cases/CheckStaffHasAccessForDocumentInCase",
  apiGetDocumentGetCase: "Nomenclature/Cases/GetCase",
  apiGetDocumentGetCaseAccessRequest: "Nomenclature/Cases/GetCaseAccessRequest",
  apiGetDocumentGetCaseAccessRequestRelatedData: "Nomenclature/Cases/GetCaseAccessRequestRelatedData",
  apiGetDocumentGetCaseCount: "Nomenclature/Cases/GetCaseCount",
  apiGetDocumentGetCaseDocuments: "Nomenclature/Cases/GetCaseDocuments",
  apiGetDocumentGetCaseLink: "Nomenclature/Cases/GetCaseLink",
  apiGetDocumentGetCases: "Nomenclature/Cases/GetCases",
  apiGetDocumentGetCasesForDocument: "Nomenclature/Cases/GetCasesForDocument",
  apiGetDocumentGetCasesForFiltering: "Nomenclature/Cases/GetCasesForFiltering",
  apiGetDocumentGetCasesNames: "Nomenclature/Cases/GetCasesNames",
  apiGetDocumentGetDocumentInCase: "Nomenclature/Cases/GetDocumentInCase",
  apiGetDocumentGetReadyForCaseDocuments: "Nomenclature/Cases/GetReadyForCaseDocuments",
  apiGetDocumentGetDocumentsInCase: "Nomenclature/Cases/GetDocumentsInCase",
  apiGetDocumentGetMembersOfCaseDocument: "Nomenclature/Cases/GetMembersOfCaseDocument",
  apiGetDocumentGetMyCases: "Nomenclature/Cases/MyCases",
  apiGetDocumentsMyCase: "Nomenclature/Cases/GetCaseDocuments",
  apiGetReceivedCaseAccesses: "Nomenclature/Cases/GetReceivedCaseAccessRequests",
  apiGetSentCaseAccesses: "Nomenclature/Cases/GetSentCaseAccessRequests",
  apiPostChangeAccessForContentInCaseDocuments: "Nomenclature/Cases/ChangeAccessForContentInCaseDocuments",
  apiPostDocumentAddCaseAccessRequest: "Nomenclature/Cases/AddCaseAccessRequest",
  apiPostDocumentApproveCaseLink: "Nomenclature/Cases/ApproveCaseLink",
  apiPostDocumentCloseAccessToDocument: "Nomenclature/Cases/CloseAccessToDocument",
  apiPostDocumentConfirmCaseAccessRequest: "Nomenclature/Cases/ConfirmCaseAccessRequest",
  apiPostDocumentPostCasesAddCaseLink: "Nomenclature/Cases/AddCaseLink",
  apiPostDocumentRejectCaseAccessRequest: "Nomenclature/Cases/RejectCaseAccessRequest",
  apiPostDocumentRevokeCaseLink: "Nomenclature/Cases/RevokeCaseLink",
  apiPostDocumentSaveAcceptDocumentInCaseLink: "Nomenclature/Cases/AcceptDocumentInCaseLink",
  apiPostDocumentSaveCases: "Nomenclature/Cases/SaveCases",
  apiPostDocumentSaveRevokeCaseLink: "Nomenclature/Cases/RevokeCaseLink",
  apiPostDocumentSetCaseAccessRequestAsRead: "Nomenclature/Cases/SetCaseAccessRequestAsRead",
  apiPostDocumentSetCaseLinkMemberReadDate: "Nomenclature/Cases/SetCaseLinkMemberReadDate",

  // Document/Documents
  apiGetDocumentGetRemovedFromControlFilters: "Document/Documents/GetRemovedFromControlFilters",
  apiGetDocumentGetControlPointsRemovedFromControl: "Document/Documents/GetControlPointsRemovedFromControl",
  apiGetDocumentGetDocumentsRemovedFromControl: "Document/Documents/GetDocumentsRemovedFromControl",
  apiGetDocumentCheckAccessForCaseDocument: "Document/Documents/CheckAccessForCaseDocument",
  apiGetDocumentCheckDocumentAccess: "Document/Documents/CheckDocumentAccess",
  apiGetDocumentDeleteDocumentRecipient: "Registration/Registration/DeleteDocumentRecipient",
  apiGetDocumentDocumentsGetDocument: "Document/Documents/GetDocument",
  apiGetDocumentGetAgreementDocuments: "Document/Documents/GetAgreementDocuments",
  apiGetDocumentGetAgreementDocumentsOfLeader: "Document/Documents/GetAgreementDocumentsOfLeader",
  apiGetDocumentGetComplaintDocument: "Document/Documents/GetComplaintDocument",
  apiGetDocumentGetComplaintDocuments: "Document/Documents/GetComplaintDocuments",
  apiGetDocumentGetComplaintDocumentsOfLeaders: "Document/Documents/GetComplaintDocumentsOfLeaders",
  apiGetDocumentGetComplaintJournalDocuments: "Registration/Registration/GetComplaintJournalDocuments",
  apiGetDocumentGetComplaintJournalDocumentsFilters: "Document/Documents/GetComplaintJournalDocumentsFilters",
  apiGetDocumentGetControlDocumentControlPoints: "Document/Documents/GetControlDocumentControlPoints",
  apiGetDocumentGetControlDocuments: "Document/Documents/GetControlDocuments",
  apiGetDocumentGetControlDocumentsFilters: "Document/Documents/GetControlDocumentsFilters",
  apiGetDocumentGetControlPoint: "Document/Documents/GetControlPoint",

  // Document/DeadlineChangeRequests — поручение muddatini o'zgartirish so'rovlari
  // (ro'yxat, sonlar, panel va qaror — «Контроль исполнения» → «Muddat so'rovlari» tabi, faqat nazorat guruhi)
  apiGetDeadlineChangeRequest: "Document/DeadlineChangeRequests/GetDeadlineChangeRequest",
  apiGetDeadlineChangeRequests: "Document/DeadlineChangeRequests/GetDeadlineChangeRequests",
  apiGetDeadlineChangeRequestsByControlPoint: "Document/DeadlineChangeRequests/GetDeadlineChangeRequestsByControlPoint",
  apiGetDeadlineChangeRequestsCounts: "Document/DeadlineChangeRequests/GetDeadlineChangeRequestsCounts",
  // So'rovchi o'zining hali ko'rib chiqilmagan so'rovini qaytarib oladi (topshiriq sahifasidagi kartochkada X).
  apiPostCancelDeadlineChangeRequest: "Document/DeadlineChangeRequests/CancelDeadlineChangeRequest",
  apiPostCreateDeadlineChangeRequest: "Document/DeadlineChangeRequests/CreateDeadlineChangeRequest",
  apiPostDecideDeadlineChangeRequest: "Document/DeadlineChangeRequests/DecideDeadlineChangeRequest",
  apiGetDocumentGetDocumentByParentDocumentMessageId: "Document/Documents/GetDocumentByParentDocumentMessageId",
  apiGetDocumentGetDocumentHistory: "Document/Documents/GetDocumentHistory",
  apiGetDocumentGetDocumentHistoryFile: "Document/Documents/GetDocumentHistoryFile",
  apiGetDocumentGetDocumentRow: "Document/Documents/GetDocumentRow",
  apiGetDocumentGetDocumentTimeline: "Document/Chronology/GetDocumentTimeline",
  apiGetDocumentGetDocumentTrack: "Document/Chronology/GetDocumentTrack",
  apiGetDocumentGetDocumentTree: "Document/Chronology/GetDocumentTree",
  apiGetDocumentGetDocumentVersions: "Document/Documents/GetDocumentVersions",
  apiGetDocumentGetDocumentsForRelation: "Document/Documents/GetDocumentsForRelation",
  apiGetDocumentGetDraftDocuments: "Document/Documents/GetDraftDocuments",
  apiGetDocumentGetExecutionProgressOfControlPoint: "Document/Documents/GetExecutionProgressOfControlPoint",
  apiGetDocumentGetFailedDocuments: "Document/Documents/GetFailedDocuments",
  apiGetDocumentGetForConsiderationDocuments: "Document/Documents/GetForConsiderationDocuments",
  apiGetDocumentGetForConsiderationDocumentsOfLeaders: "Document/Documents/GetForConsiderationDocumentsOfLeaders",
  apiGetDocumentGetForConsiderationDocumentsOfLeadersFilters: "Document/Documents/GetForConsiderationDocumentsOfLeadersFilters",
  apiGetDocumentGetForControlControlPointResolution: "Document/Documents/GetForControlResolution",
  apiGetDocumentExportForControlDocuments: "Document/Documents/ExportForControlDocuments",
  apiGetDocumentExportForControlPoints: "Document/Documents/ExportForControlPoints",
  apiGetDocumentGetForControlDocuments: "Document/Documents/GetForControlDocuments",
  apiGetDocumentGetForControlFilters: "Document/Documents/GetForControlFilters",
  apiGetDocumentGetForControlPoints: "Document/Documents/GetForControlPoints",
  apiGetDocumentGetForExecutionControlPoints: "Document/Documents/GetForExecutionControlPoints",
  apiGetDocumentGetForExecutionControlPointsOfLeaders: "Document/Documents/GetForExecutionControlPointsOfLeaders",
  apiGetDocumentGetForExecutionDocuments: "Document/Documents/GetForExecutionDocuments",
  apiGetDocumentGetForExecutionDocumentsOfLeaders: "Document/Documents/GetForExecutionDocumentsOfLeaders",
  apiGetDocumentGetForExecutionOfLeadersFilters: "Document/Documents/GetForExecutionOfLeadersFilters",
  apiGetDocumentGetForRevisionInformation: "Document/Documents/GetForRevisionInformation",
  apiGetDocumentGetHrDocuments: "Document/Documents/GetHrDocuments",
  apiGetDocumentGetHrProjectDocumentsFilters: "Document/Documents/GetHrProjectDocumentsFilters",
  apiGetDocumentGetHrOrderDocument: "Document/Documents/GetHrOrderDocument",
  apiGetDocumentGetHrOrderJournalDocuments: "Document/Documents/GetHrOrderJournalDocuments",
  apiGetDocumentGetInboxDocument: "Document/Documents/GetInboxDocument",
  apiGetDocumentGetInboxDocuments: "Document/Documents/GetInboxDocuments",
  apiGetDocumentGetIncomingDocument: "Document/Documents/GetIncomingDocument",
  apiGetDocumentGetIncomingJournalDocuments: "Registration/Registration/GetIncomingJournalDocuments",
  apiGetDocumentGetInnerDocument: "Document/Documents/GetInnerDocument",
  apiGetDocumentGetInnerJournalDocuments: "Registration/Registration/GetInnerJournalDocuments",
  apiGetDocumentGetIntegrationReceivedResolution: "Document/Documents/GetIntegrationReceivedResolution",
  apiGetDocumentGetOutboxDocument: "Document/Documents/GetOutboxDocument",
  apiGetDocumentGetOutboxDocuments: "Document/Documents/GetOutboxDocuments",
  apiGetDocumentGetOutgoingDocument: "Document/Documents/GetOutgoingDocument",
  apiGetDocumentGetOutgoingJournalDocuments: "Registration/Registration/GetOutgoingJournalDocuments",
  apiGetDocumentGetOwnResolution: "Document/Documents/GetOwnresolution",
  apiGetDocumentGetOwnResolutionByMessageId: "Document/Documents/GetOwnResolutionByMessageId",
  apiGetDocumentGetOwnResolutionControlPoints: "Document/Documents/GetOwnResolutionControlPoints",
  apiGetDocumentGetOwnResolutionDocuments: "Document/Documents/GetOwnResolutionDocuments",
  apiGetDocumentGetOwnResolutionsFilters: "Document/Documents/GetOwnResolutionsFilters",
  apiGetDocumentGetProjectDocuments: "Document/Documents/GetProjectDocuments",
  apiGetDocumentGetProjectDocumentsFilters: "Document/Documents/GetProjectDocumentsFilters",
  apiGetDocumentGetRegisteredComplaintDocument: "Registration/Registration/GetRegisteredComplaintDocument",
  apiGetDocumentGetRegisteredHrOrder: "Registration/Registration/GetRegisteredHrOrder",
  apiGetDocumentGetRegisteredIncomingDocument: "Registration/Registration/GetRegisteredIncomingDocument",
  apiGetDocumentGetRegisteredInnerDocument: "Registration/Registration/GetRegisteredInnerDocument",
  apiGetDocumentGetRegisteredOutgoingDocument: "Registration/Registration/GetRegisteredOutgoingDocument",
  apiGetDocumentGetHighestResolution: "Document/Documents/GetHighestResolution",
  apiGetDocumentGetRegulatoryDocument: "Document/Documents/GetRegulatoryDocument",
  apiGetDocumentGetRegisteredRegulatoryDocument: "Registration/Registration/GetRegisteredRegulatoryDocument",
  apiGetDocumentGetRegulatoryJournalDocuments: "Registration/Registration/GetRegulatoryJournalDocuments",
  apiGetDocumentGetRelatedDocuments: "Document/Documents/GetRelatedDocuments",
  apiGetDocumentGetResolutionAsController: "Document/Documents/GetResolutionAsController",
  apiGetDocumentGetResolutionAsPerformer: "Document/Documents/GetResolutionAsPerformer",
  apiGetDocumentGetResolutionAsPerformerAssistant: "Document/Documents/GetResolutionAsPerformerAssistant",
  apiGetDocumentGetResolutionByMessageId: "Document/Documents/GetResolutionByMessageId",
  apiGetDocumentGetResolutionForControl: "Document/Documents/GetResolutionForControl",
  apiGetDocumentGetResolutionsByDocumentId: "Document/Documents/GetResolutionsByDocumentId",
  apiGetDocumentGetResolutionSettings: "Document/Documents/GetResolutionSettings",
  apiGetDocumentGetResolutionsOfLeaders: "Document/Documents/GetResolutionsOfLeaders",
  apiGetDocumentGetSentDocuments: "Document/Documents/GetSentDocuments",
  apiGetDocumentGetSignersForResolutionByMember: "Document/Documents/GetSignersForResolutionByMember",
  apiGetDocumentRevokeResolution: "Document/Documents/RevokeResolution",
  apiGetDocumentSendDocumentControlPointsForExecution: "Document/Documents/SendDocumentControlPointsForExecution",
  apiGetDocumentSendHrOrderDocumentForSigning: "Document/Documents/SendHrOrderDocumentForSigning",
  apiGetDocumentSendInnerDocumentForSigning: "Registration/Registration/SendInnerDocumentForSigning",
  apiGetDocumentSendOutgoingDocumentForSigning: "Registration/Registration/SendOutgoingDocumentForSigning",
  apiGetDocumentSendRegulatoryDocumentForSigning: "Registration/Registration/SendRegulatoryDocumentForSigning",
  apiGetDocumentSetDocumentAsRead: "Document/Documents/SetDocumentAsRead",
  apiGetDocumentSetMemberAsRead: "Document/Documents/SetMemberAsRead",
  apiGetDocumentExportDocuments: "Document/Documents/ExportDocuments",
  apiGetDocumentExportControlPoints: "Document/Documents/ExportControlPoints",
  apiGetDocumentGetDocumentOnControlExportDocuments: "Document/Documents/GetDocumentOnControlExportDocuments",
  apiGetDocumentGetDocumentOnControlExportControlPoints: "Document/Documents/GetDocumentOnControlExportControlPoints",
  apiGetDocumentGetPerformedDocuments: "Document/Documents/GetPerformedDocuments",
  apiGetDocumentGetPerformedControlPoints: "Document/Documents/GetPerformedControlPoints",
  apiGetDocumentGetPerformedFilters: "Document/Documents/GetPerformedFilters",
  apiGetDocumentGetDocumentVersion: "Document/Documents/GetDocumentVersion",
  apiPostDocumentAddComplaintDocumentRecipient: "Registration/Registration/AddComplaintDocumentRecipient",
  apiPostDocumentAddIncomingDocumentForConsiderationRecipient: "Registration/Registration/AddIncomingDocumentForConsiderationRecipient",
  apiPostDocumentAddIncomingDocumentForExecutionRecipient: "Document/Documents/AddIncomingDocumentForExecutionRecipient",
  apiPostDocumentAddInnerDocumentForConsiderationMembers: "Registration/Registration/AddInnerDocumentForConsiderationMembers",
  apiPostDocumentAddOutgoingDocumentRecipient: "Document/Documents/AddOutgoingDocumentRecipient",
  apiPostDocumentAnswer: "Document/Documents/Answer",
  apiPostDocumentAttachResolutionAndSign: "Document/Documents/AttachResolutionAndSign",
  apiPostDocumentCheckForRelationalComplaintDocuments: "Registration/Registration/CheckForRelationalComplaintDocuments",
  apiPostDocumentCheckIfNotificationActive: "Document/Documents/CheckIfNotificationActive",
  apiPostDocumentCreateExecutionMark: "Document/Documents/CreateExecutionMark",
  apiPostDocumentCreateInnerDocument: "Document/Documents/CreateInnerDocument",
  apiPostDocumentCreateOutgoingDocument: "Document/Documents/CreateOutgoingDocument",
  apiPostDocumentCreateRegulatoryDocument: "Document/Documents/CreateRegulatoryDocument",
  apiPostDocumentDeleteDocumentRelation: "Document/Documents/DeleteDocumentRelation",
  apiPostDocumentDeleteDraftDocument: "Document/Documents/DeleteDraftDocument",
  apiPostDocumentDeleteDraftHrDocument: "Document/Documents/DeleteDraftHrDocument",
  apiPostDocumentGetDocumentRecipients: "Document/Documents/GetDocumentRecipients",
  apiPostDocumentGetHrDocumentForPersonnelBase: "Document/Documents/GetHrDocumentForPersonnelBase",
  apiPostDocumentGetHrOrderJournalDocumentsFilters: "Document/Documents/GetHrOrderJournalDocumentsFilters",
  apiPostDocumentGetIncomingJournalDocumentsFilters: "Document/Documents/GetIncomingJournalDocumentsFilters",
  apiPostDocumentGetInnerJournalDocumentsFilters: "Document/Documents/GetInnerJournalDocumentsFilters",
  apiPostDocumentRegisterComplaintDocument: "Registration/Registration/RegisterComplaintDocument",
  apiPostDocumentRegisterHrOrder: "Registration/Registration/RegisterHrOrder",
  apiPostDocumentRegisterIncomingDocument: "Registration/Registration/RegisterIncomingDocument",
  apiPostDocumentRegisterIncomingDocumentFromIntegration: "Registration/Registration/RegisterIncomingDocumentFromIntegration",
  apiPostDocumentRegisterInnerDocument: "Registration/Registration/RegisterInnerDocument",
  apiPostDocumentRegisterOutgoingDocument: "Registration/Registration/RegisterOutgoingDocument",
  apiPostDocumentGetDocumentQRCode: "Document/Documents/GetDocumentQRCode",
  apiPostDocumentRejectSignDocument: "Document/Documents/RejectSignDocument",
  apiPostDocumentRevokeAgreement: "Document/Documents/RevokeAgreement",
  apiPostDocumentAbortAgreement: "Document/Documents/AbortAgreement",
  apiPostDocumentRevokeComplaintDocumentForConsideration: "Registration/Registration/RevokeComplaintDocumentForConsideration",
  apiPostDocumentRevokeForRevisionDocument: "Document/Documents/RevokeForRevisionDocument",
  apiPostDocumentRevokeForSigningDocument: "Document/Documents/RevokeForSigningDocument",
  apiPostDocumentRevokeIncomingDocumentForConsideration: "Registration/Registration/RevokeIncomingDocumentForConsideration",
  apiPostDocumentRevokeIncomingDocumentForExecution: "Registration/Registration/RevokeIncomingDocumentForExecution",
  apiPostDocumentRevokeInnerDocumentForConsideration: "Registration/Registration/RevokeInnerDocumentForConsideration",
  apiPostDocumentRevokeInnerDocumentForExecution: "Registration/Registration/RevokeInnerDocumentForExecution",
  apiPostDocumentRevokeOutgoingDocumentForExecution: "Registration/Registration/RevokeOutgoingDocumentForExecution",
  apiPostDocumentSaveDocumentControlPointsAndSendForExecution: "Document/Documents/SaveDocumentControlPointsAndSendForExecution",
  apiPostDocumentSaveDocumentControlPointsAsDraft: "Document/Documents/SaveDocumentControlPointsAsDraft",
  apiPostDocumentSaveDocumentRelations: "Document/Documents/SaveDocumentRelations",
  apiPostDocumentSendResolutionForSign: "Document/Documents/SendResolutionForSign",
  apiPostDocumentCreateResolution: "Document/Documents/CreateResolution",
  apiPostDocumentUpdateResolution: "Document/Documents/UpdateResolution",
  apiPostDocumentSendAgreement: "Document/Documents/SendAgreement",
  apiPostDocumentSendComplaintDocumentForConsideration: "Registration/Registration/SendComplaintDocumentForConsideration",
  apiPostDocumentSendExecutionMarkForRevision: "Document/Documents/SendExecutionMarkForRevision",
  apiPostDocumentSendIncomingDocumentForConsideration: "Registration/Registration/SendIncomingDocumentForConsideration",
  apiPostDocumentSendIncomingDocumentForExecution: "Registration/Registration/SendIncomingDocumentForExecution",
  apiPostDocumentSendInnerDocumentForConsideration: "Registration/Registration/SendInnerDocumentForConsideration",
  apiPostDocumentSendInnerDocumentForRevision: "Document/Documents/SendInnerDocumentForRevision",
  apiPostDocumentSendOutgoingDocumentForConsideration: "Document/Documents/SendOutgoingDocumentForConsideration",
  apiPostDocumentSendOutgoingDocumentForRevision: "Document/Documents/SendOutgoingDocumentForRevision",
  apiPostDocumentSendRegulatoryDocumentForRevision: "Document/Documents/SendRegulatoryDocumentForRevision",
  apiPostDocumentSendResolutionForRevision: "Document/Documents/SendResolutionForRevision",
  apiPostDocumentSignHrDocument: "Document/Documents/SignHrDocument",
  apiPostDocumentSignInnerDocument: "Document/Documents/SignInnerDocument",
  apiPostDocumentSignOutgoingDocument: "Document/Documents/SignOutgoingDocument",
  apiPostDocumentSignRegulatoryDocument: "Document/Documents/SignRegulatoryDocument",
  apiPostDocumentSignResolution: "Document/Documents/SignResolution",
  apiPostDocumentTakeOffControlPointFromControl: "Document/Documents/TakeOffControlPointFromControl",
  apiPostDocumentUpdateComplaintDocument: "Registration/Registration/UpdateComplaintDocument",
  apiPostDocumentUpdateCreatedInnerDocument: "Document/Documents/UpdateCreatedInnerDocument",
  apiPostDocumentUpdateCreatedOutgoingDocument: "Document/Documents/UpdateCreatedOutgoingDocument",
  apiPostDocumentUpdateHrOrder: "Registration/Registration/UpdateHrOrder",
  apiPostDocumentUpdateIncomingDocument: "Registration/Registration/UpdateIncomingDocument",
  apiPostDocumentUpdateIncomingDocumentForIntegration: "Registration/Registration/UpdateIncomingDocumentForIntegration",
  apiPostDocumentUpdateInnerDocument: "Registration/Registration/UpdateInnerDocument",
  apiPostDocumentUpdateOutgoingDocument: "Document/Documents/UpdateOutgoingDocument",
  apiPostDocumentUpdateRegisteredInnerDocument: "Registration/Registration/UpdateRegistredInnerDocument",
  apiPostDocumentUpdateRegulatoryDocument: "Document/Documents/UpdateRegulatoryDocument",
  apiPostDocumentWriteComment: "Document/Documents/WriteComment",

  // Document/DocumentCounter
  apiGetDocumentGetInnerDocumentStatistics: "Document/DocumentCounter/GetInnerDocumentStatistics",
  apiGetDocumentGetIncomingDocumentStatistics: "Document/DocumentCounter/GetIncomingDocumentStatistics",
  apiGetDocumentGetComplaintDocumentStatistics: "Document/DocumentCounter/GetComplaintDocumentStatistics",
  apiGetDocumentGetRegulatoryDocumentStatistics: "Document/DocumentCounter/GetRegulatoryDocumentStatistics",
  apiGetDocumentGetControllerExecutionStatistics: "Document/DocumentCounter/GetControllerExecutionStatistics",
  apiGetDocumentGetControllerPerformerOptions: "Document/DocumentCounter/GetControllerPerformerOptions",
  apiGetDocumentGetControllerCorrespondentOptions: "Document/DocumentCounter/GetControllerCorrespondentOptions",
  apiGetDocumentGetDepartmentExecutionStatistics: "Document/DocumentCounter/GetDepartmentExecutionStatistics",
  apiGetDocumentGetEmployeeExecutionStatistics: "Document/DocumentCounter/GetEmployeeExecutionStatistics",
  apiGetExecutionScopeDepartmentStatistics: "Document/ExecutionScope/GetDepartmentExecutionStatistics",
  apiGetExecutionScopeDepartmentDocumentStatistics: "Document/ExecutionScope/GetDepartmentDocumentStatistics",
  apiGetExecutionScopeEmployeeStatistics: "Document/ExecutionScope/GetEmployeeExecutionStatistics",
  apiGetExecutionScopeSelfDeadlineBuckets: "Document/ExecutionScope/GetSelfDeadlineBuckets",
  apiGetExecutionScopeSelfDeadlineOverview: "Document/ExecutionScope/GetSelfDeadlineOverview",
  apiGetExecutionScopeControllerEmployeeStatistics: "Document/ExecutionScope/GetControllerEmployeeStatistics",
  apiGetExecutionScopeControllerDepartmentStatistics: "Document/ExecutionScope/GetControllerDepartmentStatistics",
  apiGetExecutionScopeCorrespondentOptions: "Document/ExecutionScope/GetCorrespondentOptions",
  apiGetExecutionScopeCorrespondentDocumentStatistics: "Document/ExecutionScope/GetCorrespondentDocumentStatistics",
  apiGetExecutionScopeCorrespondentControlPointStatistics: "Document/ExecutionScope/GetCorrespondentControlPointStatistics",
  apiGetExecutionScopeControllerCorrespondentStatistics: "Document/ExecutionScope/GetControllerCorrespondentStatistics",
  apiGetExecutionScopeControllerDepartmentDocumentStatistics: "Document/ExecutionScope/GetControllerDepartmentDocumentStatistics",
  apiGetExecutionScopeControllerCorrespondentDocumentStatistics: "Document/ExecutionScope/GetControllerCorrespondentDocumentStatistics",
  apiGetExecutionScopeGetIsControlGroup: "Document/ExecutionScope/GetIsControlGroup",
  apiGetDocumentGetDailyControlPointProgress: "Document/ExecutionTrend/GetDailyControlPointProgress",
  apiGetDocumentGetDailyControllerDocumentProgress: "Document/ExecutionTrend/GetDailyControllerDocumentProgress",
  apiGetDocumentGetDailyDocumentProgress: "Document/ExecutionTrend/GetDailyDocumentProgress",
  apiGetDocumentGetDailyPerformerControlPointProgress: "Document/ExecutionTrend/GetDailyPerformerControlPointProgress",
  apiGetDocumentGetDocumentOnTimeStatistics: "Document/ExecutionTrend/GetDocumentOnTimeStatistics",
  apiGetDocumentGetExecutionDrilldownControlPoints: "Document/ExecutionDrilldown/GetControlPoints",
  apiGetDocumentGetExecutionDrilldownControllerControlPoints: "Document/ExecutionDrilldown/GetControllerControlPoints",
  apiGetDocumentGetExecutionDrilldownDocuments: "Document/ExecutionDrilldown/GetDocuments",
  apiGetDocumentGetExecutionDrilldownControllerDocuments: "Document/ExecutionDrilldown/GetControllerDocuments",
  apiGetDocumentGetExecutionDrilldownDailyControllerDocuments: "Document/ExecutionDrilldown/GetDailyControllerDocuments",
  apiGetDocumentGetExecutionDrilldownDailyDocuments: "Document/ExecutionDrilldown/GetDailyDocuments",
  apiGetDocumentGetExecutionDrilldownDailyControllerControlPoints: "Document/ExecutionDrilldown/GetDailyControllerControlPoints",
  apiGetDocumentGetExecutionDrilldownDailyPerformerControlPoints: "Document/ExecutionDrilldown/GetDailyPerformerControlPoints",
  apiGetDocumentExecutionDrilldownExportDocuments: "Document/ExecutionDrilldown/ExportDocuments",
  apiGetDocumentExecutionDrilldownExportControlPoints: "Document/ExecutionDrilldown/ExportControlPoints",
  apiGetDocumentGetForConsiderationDocumentsFilters: "Document/DocumentCounter/GetForConsiderationDocumentsFilters",
  apiGetDocumentGetForExecutionFilters: "Document/DocumentCounter/GetForExecutionFilters",
  apiGetDocumentGetMenuCounters: "Document/DocumentCounter/GetMenuCounters",
  apiGetDocumentGetAgreementFilters: "Document/DocumentCounter/GetAgreementFilters",

  // Document/DocumentTypes
  apiPostDocumentTypeEntityState: "Document/DocumentTypes/UpdateDocumentTypeEntityState",
  apiGetDocumentGetDocumentType: "Document/DocumentTypes/GetDocumentType",
  apiGetDocumentGetDocumentTypeNameByLanguage: "Document/DocumentTypes/GetDocumentTypeNameByLanguage",
  apiGetDocumentGetDocumentTypes: "Document/DocumentTypes/GetDocumentTypes",
  apiGetDocumentGetDocumentTypesForRelation: "Document/DocumentTypes/GetDocumentTypesForRelation",
  apiGetDocumentGetReferencesDocumentTypes: "Document/DocumentTypes/GetReferencesDocumentTypes",
  apiGetDocumentGetTemplateDocumentTypes: "Document/DocumentTypes/GetTemplateDocumentTypes",
  apiGetDocumentRelationGetRelatedDocumentTypes: "Document/DocumentTypes/GetRelatedDocumentTypes",
  apiPostDocumentCreateDocumentType: "Document/DocumentTypes/CreateDocumentType",
  apiPostDocumentUpdateDocumentType: "Document/DocumentTypes/UpdateDocumentType",
  apiPostDocumentUpdateDocumentTypeSequence: "Document/DocumentTypes/UpdateDocumentTypeSequence",

  // Document/DocumentViews
  apiPostDocumentViewEntityState: "Document/DocumentViews/UpdateDocumentViewEntityState",
  apiGetDocumentGetGroupedTemplateDocumentViews: "Document/DocumentViews/GetGroupedTemplateDocumentViews",
  apiGetDocumentGetDocumentView: "Document/DocumentViews/GetDocumentView",
  apiGetDocumentGetDocumentViewByIdentifier: "/Document/DocumentViews/GetDocumentViewByIdentifier",
  apiGetDocumentGetDocumentViewNameByLanguage: "Document/DocumentViews/GetDocumentViewNameByLanguage",
  apiGetDocumentGetDocumentViews: "Document/DocumentViews/GetDocumentViews",
  apiGetDocumentGetDocumentViewsAsPagination: "Document/DocumentViews/GetDocumentViewsAsPagination",
  apiGetDocumentGetDocumentViewsByTypesIdentifiers: "Document/DocumentViews/GetDocumentViewsByTypesIdentifiers",
  apiGetDocumentGetDocumentViewsForRelation: "Document/DocumentViews/GetDocumentViewsForRelation",
  apiGetDocumentGetDocumentViewsToCreateTemplate: "Document/DocumentViews/GetDocumentViewsToCreateTemplate",
  apiGetDocumentGetDocumentViewsWithTranslationsAsPagination: "Document/DocumentViews/GetDocumentViewsWithTranslationsAsPagination",
  apiGetDocumentRelationGetRelatedDocumentViews: "Document/DocumentViews/GetRelatedDocumentViews",
  apiPostDocumentCreateDocumentView: "Document/DocumentViews/CreateDocumentView",
  apiPostDocumentDeleteDocumentView: "Document/DocumentViews/DeleteDocumentView",
  apiPostDocumentUpdateDocumentView: "Document/DocumentViews/UpdateDocumentView",
  apiPostDocumentUpdateDocumentViewSequence: "Document/DocumentViews/UpdateDocumentViewSequence",

  // Document/DocumentJournals
  apiPostDocumentJournalEntityState: "Document/DocumentJournals/UpdateDocumentJournalEntityState",
  apiGetDocumentCheckItHasStaffingTable: "Document/DocumentJournals/CheckItHasStaffingTable",
  apiGetDocumentGetDocumentJournalById: "Document/DocumentJournals/GetDocumentJournalById",
  apiGetDocumentGetDocumentJournalNamesByLanguage: "Document/DocumentJournals/GetDocumentJournalNamesByLanguage",
  apiGetDocumentGetDocumentJournals: "Document/DocumentJournals/GetDocumentJournals",
  apiGetDocumentGetDocumentJournalsByType: "Document/DocumentJournals/GetDocumentJournalsByType",
  apiGetDocumentGetDocumentJournalsForRelation: "Document/DocumentJournals/GetDocumentJournalsForRelation",
  apiGetDocumentRelationGetRelatedDocumentJournals: "Document/DocumentJournals/GetRelatedDocumentJournals",
  apiPostDocumentCreateDocumentJournal: "Document/DocumentJournals/CreateDocumentJournal",
  apiPostDocumentCreateDocumentJournalRelate: "/Document/DocumentJournals/CreateDocumentJournalRelate",
  apiPostDocumentUpdateDocumentJournal: "Document/DocumentJournals/UpdateDocumentJournal",
  apiPostDocumentUpdateDocumentJournalSequence: "Document/DocumentJournals/UpdateDocumentJournalSequence",

  // Document/BusinessTrip
  apiGetDocumentGetStaffsBusinessTripPeriods: "Document/BusinessTrip/GetStaffsBusinessTripPeriods",
  apiGetDocumentGetOnBusinessTripStatusByPerson: "Document/BusinessTrip/GetOnBusinessTripStatusByPerson",
  apiGetDocumentGetStaffOnBusinessTripsHistory: "Document/BusinessTrip/GetStaffOnBusinessTripsHistory",
  apiGetDocumentGetBusinessTripDocument: "Document/BusinessTrip/GetBusinessTripDocument",
  apiGetDocumentGetStaffsOnBusinessTrip: "Document/BusinessTrip/GetStaffsOnBusinessTrip",
  apiPostDocumentCreateBusinessTripDocument: "Document/BusinessTrip/CreateBusinessTripDocument",
  apiPostDocumentUpdateBusinessTripDocument: "Document/BusinessTrip/UpdateBusinessTripDocument",

  // Document/DocumentFilter
  apiGetDocumentGetFilter: "Document/DocumentFilter/GetFilter",
  apiGetDocumentGetCardFolders: "Document/DocumentFilter/GetCardFolders",
  apiPostDocumentSaveFilter: "Document/DocumentFilter/SaveFilter",
  apiPostDocumentSaveCardFolder: "Document/DocumentFilter/SaveCardFolder",
  apiPostDocumentDeleteCardFolder: "Document/DocumentFilter/DeleteCardFolder",
  apiPostDocumentDeleteFilter: "Document/DocumentFilter/DeleteFilter",

  // Kpi/Criteria
  apiGetKpiGetActiveCriteria: "Kpi/Criteria/GetActive",
  apiGetKpiGetCriteria: "Kpi/Criteria/Get",
  apiGetKpiGetCriteriaById: "Kpi/Criteria/GetById",
  apiGetKpiGetCriteriaScope: "Kpi/Criteria/GetScope",
  apiPostKpiArchiveCriteria: "Kpi/Criteria/Archive",
  apiPostKpiRestoreCriteria: "Kpi/Criteria/Restore",
  apiPostKpiSaveCriteria: "Kpi/Criteria/Save",
  // Kpi/Status
  apiGetKpiPing: "Kpi/Status/Ping",
  // Kpi/Scores
  apiGetKpiExportAnalytics: "Kpi/Scores/ExportAnalytics",
  apiGetKpiGetAnalytics: "Kpi/Scores/GetAnalytics",
  apiGetKpiGetMy: "Kpi/Scores/GetMy",
  apiGetKpiGetStaffScores: "Kpi/Scores/GetStaffScores",
  apiGetKpiGetSubordinates: "Kpi/Scores/GetSubordinates",
  apiPostKpiCancelScore: "Kpi/Scores/Cancel",
  apiPostKpiGiveScores: "Kpi/Scores/Give",
  apiPostKpiUpdateScore: "Kpi/Scores/Update",

  // Nomenclature/Nomenclatures
  apiGetDocumentGetActiveNomenclature: "Nomenclature/Nomenclatures/GetActiveNomenclature",
  apiGetDocumentGetNomenclature: "Nomenclature/Nomenclatures/GetNomenclature",
  apiGetDocumentGetNomenclatureDocuments: "Nomenclature/Nomenclatures/GetNomenclatureDocuments",
  apiGetDocumentGetNomenclatures: "Nomenclature/Nomenclatures/GetNomenclatures",
  apiPostDocumentActivateNomenclature: "Nomenclature/Nomenclatures/ActivateNomenclature",
  apiPostDocumentApproveNomenclature: "Nomenclature/Nomenclatures/ApproveNomenclature",
  apiPostDocumentDeleteNomenclature: "Nomenclature/Nomenclatures/DeleteNomenclature",

  // Document/TransferDocuments
  apiGetDocumentGetStaffsInformationsForTransferDocument: "Document/TransferDocuments/GetStaffsInformationsForTransferDocument",
  apiGetDocumentGetTransferDocuments: "Document/TransferDocuments/GetTransferDocuments",
  apiGetDocumentGetDocumentsForTransfer: "Document/TransferDocuments/GetDocumentsForTransfer",
  apiGetDocumentCheckItHasTransferDocument: "Document/TransferDocuments/CheckItHasTransferDocument",
  apiGetDocumentTransferDocumentsById: "Document/TransferDocuments/GetTransferDocument",
  apiGetDocumentGetTransferedDocuments: "Document/TransferDocuments/GetTransferedDocuments",
  apiPostDocumentCreateTransferDocument: "Document/TransferDocuments/CreateTransferDocument",
  apiPostDocumentUpdateTransferDocument: "Document/TransferDocuments/UpdateTransferDocument",
  apiPostDocumentDeleteTransferDocument: "Document/TransferDocuments/DeleteTransferDocument",
  apiPostDocumentAcceptTransferDocument: "Document/TransferDocuments/AcceptTransferDocument",
  apiPostDocumentRejectTransferDocument: "Document/TransferDocuments/RejectTransferDocument",

  // Document/DocumentFiles
  apiPostDocumentDeleteFile: "Document/DocumentFiles/DeleteFile",

  // Editor/Templates
  apiGetEditorImportTemplates: "Editor/Templates/ImportTemplates",
  apiGetEditorsExportTemplate: "Editor/Templates/ExportTemplate",
  apiGetTemplatesGetAllTemplates: "Editor/Templates/GetAllTemplates",
  apiPostEditorCloneTemplateFile: "Editor/Templates/CloneTemplateFile",
  apiPostEditorCreateTemplate: "Editor/Templates/CreateTemplate",
  apiPostEditorCreateTemplateFileInstance: "Editor/Templates/CreateTemplateFileInstance",
  apiPostEditorGetTemplateById: "Editor/Templates/GetTemplateById",
  apiPostEditorRemoveTemplate: "Editor/Templates/RemoveTemplate",

  // Editor/TagDictionary
  apiGetTagDictionaryGetTagDictionaries: "Editor/TagDictionary/GetTagDictionaries",
  apiGetTagDictionaryGetTagDictionary: "Editor/TagDictionary/GetTagDictionary",
  apiGetTagDictionaryCreateTagDictionary: "Editor/TagDictionary/CreateTagDictionary",
  apiGetTagDictionaryUpdateTagDictionary: "Editor/TagDictionary/UpdateTagDictionary",

  // Editor/Editors
  apiGetEditorsGetConfig: "Editor/Editors/GetConfig",
  apiPostEditorCreateEmptyFile: "Editor/Editors/CreateEmptyFile",
  apiPostEditorCreateTemporaryFile: "Editor/Editors/CreateTemporaryFile",

  // Editor/Tags
  apiGetEditorsGetTags: "Editor/Tags/GetTags",

  // Editor/Viewers
  apiGetEditorViewFile: "Editor/Viewers/ViewFile",

  // Environment/Environment
  apiGetEnvironmentGetAllEnvironments: "Environment/Environment/GetAllEnvironments",
  apiGetEnvironmentGetEnvironmentById: "Environment/Environment/GetEnvironmentById",
  apiGetEnvironmentGetEnvironmentIdentifiers: "Environment/Environment/GetEnvironmentIdentifiers",
  apiGetEnvironmentGetEnvironments: "Environment/Environment/GetEnvironments",
  apiPostEnvironmentCreateEnvironment: "Environment/Environment/CreateEnvironment",
  apiPostEnvironmentDeleteEnvironment: "Environment/Environment/DeleteEnvironment",
  apiPostEnvironmentUpdateEnvironment: "Environment/Environment/UpdateEnvironment",
  apiPostEnvironmentUpdateEnvironmentSequence: "Environment/Environment/UpdateEnvironmentSequence",

  // File/Files
  apiGetFileDownloadFile: "File/Files/DownloadFile",
  apiPostFileUploadFile: "File/Files/UploadFile",
  apiGetFileGetFile: "File/Files/GetFile",
  apiGetFileGetFileWithContent: "File/Files/GetFileWithContent",
  apiGetFileViewFile: "File/Files/ViewFile",
  apiPostFileCleanAllFiles: "File/Files/CleanAllFiles",
  apiPostFileCleanFile: "File/Files/CleanFile",
  apiPostFileGetFiles: "File/Files/GetFiles",
  apiPostFileRemoveFile: "File/Files/RemoveFile",
  apiPostFileUploadFileAsPDF: "File/Files/UploadFileAsPDF",

  // Form/Forms
  apiGetFormGetForms: "Form/Forms/GetForms",
  apiPostFormCreateForm: "Form/Forms/CreateForm",

  // Grid/DynamicTableSetting
  apiGetGridGetDynamicTableSettingById: "Grid/DynamicTableSetting/GetDynamicTableSettingById",
  apiGetGridGetSettingIdentifiers: "Grid/DynamicTableSetting/GetSettingIdentifiers",
  apiGetGridGetTables: "Grid/DynamicTableSetting/GetTables",
  apiPostGridCreateTable: "Grid/DynamicTableSetting/CreateTable",
  apiPostGridDeleteDynamicTableSetting: "Grid/DynamicTableSetting/DeleteDynamicTableSetting",

  // Grid/DynamicTableColumn
  apiGetGridGetGetSettingAndColumnsBySettingIdentifier: "Grid/DynamicTableColumn/GetSettingAndColumnsBySettingIdentifier",
  apiPostGridMergeUserColumn: "Grid/DynamicTableColumn/MergeUserColumn",
  apiPostGridResetUserColumn: "Grid/DynamicTableColumn/ResetUserColumn",
  apiPostGridUpdateColumn: "Grid/DynamicTableColumn/UpdateColumn",
  apiPostGridUpdateUserWidth: "Grid/DynamicTableColumn/UpdateUserWidth",

  // License
  apiGetLicenseInformation: "/License/GetLicenseInformation",

  // Module/Modules
  apiGetModuleGetAvailableMenus: "Module/Modules/GetAvailableMenus",
  apiGetModuleGetGetModuleIcon: "Module/Modules/GetModuleIcon?moduleId=",
  apiGetModuleGetModulesWithMenus: "Module/Modules/GetModulesWithMenus",

  // News/News
  apiGetNewsGetNews: "News/News/GetNews",
  apiGetNewsGetNewsById: "News/News/GetNewsById",
  apiPostNewsCreateNews: "News/News/CreateNews",
  apiPostNewsDeleteNews: "News/News/DeleteNews",
  apiPostNewsPrintNews: "News/News/PrintNews",
  apiPostNewsUpdateNews: "News/News/UpdateNews",

  // Notification/NotificationModel
  apiGetNotificationGetAllNotificationModels: "Notification/NotificationModel/GetAllNotificationModels",
  apiGetNotificationGetAllPersonNotification: "Notification/NotificationModel/GetAllPersonNotification",
  apiGetNotificationGetNotificationSubjects: "Notification/NotificationModel/GetNotificationSubjects",
  apiPostNotificationChangeAllSoundPersonNotification: "Notification/NotificationModel/ChangeAllSoundPersonNotification",
  apiPostNotificationSetTurnAllEnabledPersonNotification: "Notification/NotificationModel/SetTurnAllEnabledPersonNotification",
  apiPostNotificationUpdateNotificationSubjectContent: "Notification/NotificationModel/UpdateNotificationSubjectContent",
  apiPostNotificationUpdatePersonNotification: "Notification/NotificationModel/UpdatePersonNotification",

  // Notification/Notifications
  apiGetNotificationGetUserNotificationById: "Notification/Notifications/GetUserNotification",
  apiGetNotificationGetUserNotifications: "Notification/Notifications/GetUserNotifications",
  apiGetNotificationGetNotificationsCount: "Notification/Notifications/GetNotificationsCount",
  apiPostNotificationSetAllNotificationsAsRead: "Notification/Notifications/SetAllNotificationsAsRead",
  apiPostNotificationSetNotificationAsRead: "Notification/Notifications/SetNotificationAsRead",

  //  Delivery — hujjatning tashqi tashkilotlarga yetkazilishi.
  //  DIQQAT: bu ikki yo'l API Gateway orqali EMAS, to'g'ridan-to'g'ri Integration servisiga
  //  (config.integrationUrl, o'z porti) yuboriladi — shuning uchun servis prefiksi yo'q.
  apiGetIntegrationGetDeliveryStatus: "Delivery/GetStatus",
  apiPostIntegrationRetryDelivery: "Delivery/Retry",

  //  Partners — sherik tashkilotlar va ularning xodimlari. Bular ham Integration servisining
  //  o'z portiga (config.integrationUrl) ketadi, gateway orqali emas.
  apiGetIntegrationPartnerOutStaffs: "Partners/GetOutStaffs",
  apiGetIntegrationPartners: "Partners/GetOrganizations",
  apiPostIntegrationSyncOrganization: "Partners/SyncOrganization",

  //  Organization/Organizations
  apiGetOrganizationCheckOrganizationIdentifierExists: "Organization/Organizations/CheckOrganizationIdentifierExists",
  apiGetOrganizationGetOrganization: "Organization/Organizations/GetOrganization",
  apiGetOrganizationGetOrganizationAsPagination: "Organization/Organizations/GetOrganizationAsPagination",
  apiGetOrganizationGetOrganizations: "Organization/Organizations/GetOrganizations",
  apiGetOrganizationGetOrganizationsDictionary: "Organization/Organizations/GetOrganizationsDictionary",
  apiGetOrganizationGetOrganizationsForRelation: "Organization/Organizations/GetOrganizationsForRelation",
  apiGetOrganizationRelationGetRelatedOrganizations: "Organization/Organizations/GetRelatedOrganizations",
  apiPostOrganizationCreateOrganization: "Organization/Organizations/CreateOrganization",
  apiPostOrganizationCreateOrganizationWithDatabase: "Organization/Organizations/CreateOrganizationWithDatabase",
  apiPostOrganizationDeleteOrganization: "Organization/Organizations/DeleteOrganization",
  apiPostOrganizationGetOrganizationNameTranslations: "Organization/Organizations/GetOrganizationNameTranslations",
  apiPostOrganizationsUpdateOrganizationWithDatabase: "Organization/Organizations/UpdateOrganizationWithDatabase",
  apiPostOrganizationUpdateAdminPassword: "Organization/Organizations/UpdateAdminPassword",
  apiPostOrganizationUpdateOrganization: "Organization/Organizations/UpdateOrganization",
  apiPostOrganizationUpdateOrganizationEntityState: "Organization/Organizations/UpdateOrganizationEntityState",
  apiPostOrganizationUpdateOrganizationSequence: "Organization/Organizations/UpdateOrganizationSequence",
  apiPostOrganizationUpdateShortOrganization: "Organization/Organizations/UpdateShortOrganization",

  // Report/Reports
  apiGetReportCreateReport: "Report/Reports/CreateReport",
  apiGetReportGetColumns: "Report/Reports/GetColumns",
  apiGetReportGetFilters: "Report/Reports/GetFilters",
  apiGetReportGetFolders: "Report/Reports/GetFolders",
  apiGetReportGetHistories: "Report/Reports/GetHistories",

  // Security/DigitalSign
  apiGetSecurityConfirmCertificate: "Security/DigitalSign/ConfirmCertificate",
  apiGetSecurityVerifyFileSigns: "Security/DigitalSign/VerifyFileSigns",
  apiPostSecurityBlockCertificate: "Security/DigitalSign/BlockCertificate",
  apiPostSecurityCreateCertificate: "Security/DigitalSign/CreateCertificate",
  apiPostSecurityGetInformationFromCertificationFile: "Security/DigitalSign/GetInformationFromCertificationFile",
  apiPostSecurityUnBlockCertificate: "Security/DigitalSign/UnBlockCertificate",

  // Security/SecrecyLevels
  apiGetSecurityGetAllSecrecyLevelLevels: "Security/SecrecyLevels/GetAllSecrecyLevelLevels",
  apiGetSecurityGetAllSecrecyLevelsForView: "Security/SecrecyLevels/GetAllSecrecyLevelsForView",
  apiGetSecurityGetAllSecrecyLevelTranslations: "Security/SecrecyLevels/GetAllSecrecyLevelTranslations",
  apiGetSecurityGetSecrecyLevel: "Security/SecrecyLevels/GetSecrecyLevel",
  apiGetSecurityGetSecrecyLevels: "Security/SecrecyLevels/GetSecrecyLevels",
  apiGetSecurityGetSecrecyLevelsAsPagination: "Security/SecrecyLevels/GetSecrecyLevelsAsPagination",
  apiGetSecurityGetSecrecyLevelsEntity: "Security/SecrecyLevels/GetSecrecyLevelsEntity",
  apiGetSecurityGetRelatedSecrecyLevels: "Security/SecrecyLevels/GetRelatedSecrecyLevels",
  apiGetSecurityGetSecrecyLevelsWithTranslationsAsPagination: "Security/SecrecyLevels/GetSecrecyLevelsWithTranslationsAsPagination",
  apiPostSecurityCreateSecrecyLevel: "Security/SecrecyLevels/CreateSecrecyLevel",
  apiPostSecurityUpdateSecrecyLevel: "Security/SecrecyLevels/UpdateSecrecyLevel",

  // StaffManagement/Coups
  apiGetStaffManagementCanculateCoupStep: "StaffManagement/Coups/CanculateCoupStep",
  apiGetStaffManagementGetCoups: "StaffManagement/Coups/GetCoups",
  apiGetStaffManagementGetStaffProjects: "StaffManagement/Coups/GetStaffProjects",
  apiPostStaffManagementDeleteAllActiveStaffProjects: "StaffManagement/Coups/DeleteAllActiveStaffProjects",
  apiPostStaffManagementFinishMergingCoups: "StaffManagement/Coups/FinishMergingCoups",
  apiPostStaffManagementSendCoupsForSigning: "StaffManagement/Coups/SendCoupsForSigning",
  apiPostStaffManagementUpdateCoups: "StaffManagement/Coups/UpdateCoups",
  apiPostStaffManagementUpdateStaffProjectTransition: "StaffManagement/Coups/UpdateStaffProjectTransition",

  // StaffManagement/Posts
  apiGetStaffManagementCheckPostName: "StaffManagement/Posts/CheckPostName",
  apiGetStaffManagementGetPost: "StaffManagement/Posts/GetPost",
  apiGetStaffManagementGetPosts: "StaffManagement/Posts/GetPosts",
  apiGetStaffManagementGetPostsAsPagination: "StaffManagement/Posts/GetPostsAsPagination",
  apiGetStaffManagementGetPostsForRelation: "StaffManagement/Posts/GetPostsForRelation",
  apiGetStaffManagementGetPostsNameTranslations: "StaffManagement/Posts/GetPostsNameTranslations",
  apiGetStaffManagementGetRelatedPosts: "StaffManagement/Posts/GetRelatedPosts",
  apiPostStaffManagementCreatePost: "StaffManagement/Posts/CreatePost",
  apiPostStaffManagementDeletePost: "StaffManagement/Posts/DeletePost",
  apiPostStaffManagementResetSequence: "StaffManagement/Posts/ResetSequence",
  apiPostStaffManagementUpdatePost: "StaffManagement/Posts/UpdatePost",
  apiPostStaffManagementUpdatePostEntityState: "StaffManagement/Posts/UpdatePostEntityState",
  apiPostStaffManagementUpdatePostSequence: "StaffManagement/Posts/UpdatePostSequence",

  // StaffManagement/Group
  apiGetStaffManagementCreateStaffFavoriteGroup: "StaffManagement/Group/CreateStaffFavoriteGroup",
  apiGetStaffManagementGetAllGroups: "StaffManagement/Group/GetGroups",
  apiGetStaffManagementGetAllGroupsAndFavorities: "StaffManagement/Group/GetAllGroupsAndFavorities",
  apiGetStaffManagementGetAllStaffFavoriteGroups: "StaffManagement/Group/GetAllStaffFavoriteGroups",
  apiGetStaffManagementGetGroup: "StaffManagement/Group/GetGroup",
  apiGetStaffManagementGetGroupMembers: "StaffManagement/Group/GetGroupMembers",
  apiGetStaffManagementGetGroupNameByLanguage: "StaffManagement/Group/GetAllGroupTranslations",
  apiGetStaffManagementGetOwnGroups: "StaffManagement/Group/GetOwnGroups",
  apiGetStaffManagementGetOrganizationsWithFilter: "StaffManagement/Group/GetOrganizationsWithFilter",
  apiGetStaffManagementGetPhysicalPersons: "StaffManagement/Group/GetPhysicalPersons",
  apiGetStaffManagementGetRecipientsList: "StaffManagement/Group/GetRecipientsList",
  apiGetStaffManagementGetRecipientsListWithTranslations: "StaffManagement/Group/GetRecipientsListWithTranslations",
  apiGetStaffManagementGetStaffFavoriteResolutionContents: "StaffManagement/Group/GetStaffFavoriteResolutionContents",
  apiGetStaffManagementGetStaffsAndOrganizations: "StaffManagement/Group/GetStaffsAndOrganizations",
  apiGetStaffManagementGetStaffsAndOutStaffs: "StaffManagement/Group/GetStaffsAndOutStaffs",
  apiGetStaffManagementSaveStaffFavoriteDictionaryItems: "StaffManagement/Group/SaveStaffFavoriteDictionaryItems",
  apiGetStaffManagementSaveStaffFavoriteGroups: "StaffManagement/Group/SaveStaffFavoriteGroups",
  apiGetStaffManagementsGetFavorites: "StaffManagement/Group/GetFavorites",
  apiPostStaffManagementAddFavorite: "StaffManagement/Group/AddFavorite",
  apiPostStaffManagementCreateGroup: "StaffManagement/Group/CreateGroup",
  apiPostStaffManagementDeleteFavorite: "StaffManagement/Group/DeleteFavorite",
  apiPostStaffManagementDeleteGroup: "StaffManagement/Group/DeleteGroup",
  apiPostStaffManagementDeleteStaffFavoriteGroup: "StaffManagement/Group/DeleteStaffFavoriteGroup",
  apiPostStaffManagementUpdateGroup: "StaffManagement/Group/UpdateGroup",

  // StaffManagement/Roles
  apiGetStaffManagementGetAllStaffRoles: "StaffManagement/Roles/GetAllStaffRoles",
  apiGetStaffManagementGetAllStaffRoleStaffs: "StaffManagement/Roles/GetAllStaffRoleStaffs",
  apiGetStaffManagementGetStaffRole: "StaffManagement/Roles/GetStaffRole",
  apiGetStaffManagementGetRoleIdentifiers: "StaffManagement/Roles/GetRoleIdentifiers",
  apiGetStaffManagementGetStaffRoles: "StaffManagement/Roles/GetStaffRoles",
  apiGetStaffManagementRemoveStaffRole: "StaffManagement/Roles/RemoveStaffRole",
  apiPostStaffManagementSaveStaffRole: "StaffManagement/Roles/SaveStaffRole",

  // StaffManagement/Staff
  apiGetStaffManagementGetAllStaffs: "StaffManagement/Staff/GetAllStaffs",
  apiGetStaffManagementGetRecipientsWithBusinessTrips: "StaffManagement/Staff/GetRecipientsWithBusinessTrips",
  apiGetStaffManagementGetAllStaffsByDepartmentId: "StaffManagement/Staff/GetAllStaffsByDepartmentId",
  apiGetStaffManagementGetCandidatesForVacancy: "StaffManagement/Staff/GetCandidatesForVacancy",
  apiGetStaffManagementGetCurrentStaffsByDepartmentId: "StaffManagement/Staff/GetCurrentStaffsByDepartmentId",
  apiGetStaffManagementGetDepartmentsAndPostsForVacancies: "StaffManagement/Staff/GetDepartmentsAndPostsForVacancies",
  apiGetStaffManagementGetFreeVacancies: "StaffManagement/Staff/GetFreeVacancies",
  apiGetStaffManagementGetReserveVacancies: "StaffManagement/Staff/GetReserveVacancies",
  apiGetStaffManagementGetDraftStaffingTablePostsByDepartmentIdAndStaffingTableId:
    "StaffManagement/Staff/GetDraftStaffingTablePostsByDepartmentIdAndStaffingTableId",
  apiGetStaffManagementGetHiredStaffs: "StaffManagement/Staff/GetHiredStaffs",
  apiGetStaffManagementGetInControlStaffs: "StaffManagement/Staff/GetInControlStaffs",
  apiGetStaffManagementGetInSynchronizationStaffs: "StaffManagement/Staff/GetInSynchronizationStaffs",
  apiGetStaffManagementGetStaff: "StaffManagement/Staff/GetStaff",
  apiGetStaffManagementGetStaffOlap: "StaffManagement/Staff/GetStaffOlap",
  apiGetStaffManagementGetStaffingTablePerson: "StaffManagement/Staff/GetStaffingTablePerson",
  apiGetStaffManagementGetStaffingTablePost: "StaffManagement/Staff/GetStaffingTablePost",
  apiGetStaffManagementGetStaffingTablePosts: "StaffManagement/Staff/GetStaffingTablePosts",
  apiGetStaffManagementGetStaffingTablePostsByDepartmentIdAndStaffingTableId:
    "StaffManagement/Staff/GetStaffingTablePostsByDepartmentIdAndStaffingTableId",
  apiGetStaffManagementGetStaffRecipients: "StaffManagement/Staff/GetStaffRecipients",
  apiGetStaffManagementGetStaffs: "StaffManagement/Staff/GetStaffs",
  // Hujjat grifiga ruxsati yetmaydigan xodimlar (body: { secrecyLevelId, staffIds })
  apiPostStaffManagementGetStaffsBelowSecrecyLevel: "StaffManagement/Staff/GetStaffsBelowSecrecyLevel",
  apiGetStaffManagementGetStaffsByDepartmentId: "StaffManagement/Staff/GetStaffsByDepartmentId",
  apiGetStaffManagementGetStaffsByDepartmentIdForControl: "StaffManagement/Staff/GetStaffsByDepartmentIdForControl",
  apiGetStaffManagementGetStaffsByDepartmentIdForSecurityPage: "StaffManagement/Staff/GetStaffsByDepartmentIdForSecurityPage",
  apiGetStaffManagementGetStaffsByFilter: "StaffManagement/Staff/GetStaffsByFilter",
  apiGetStaffManagementGetStaffsBySecrecyLevelIdAsPagination: "StaffManagement/Staff/GetStaffsBySecrecyLevelIdAsPagination",
  apiGetStaffManagementGetStaffsByStaffRoleId: "StaffManagement/Staff/GetStaffsByStaffRoleId",
  apiGetStaffManagementGetVacancies: "StaffManagement/Staff/GetVacancies",
  apiPostStaffManagementSaveStaffsForInControl: "StaffManagement/Staff/SaveStaffsForInControl",
  apiPostStaffManagementSaveStaffsForSynchronization: "StaffManagement/Staff/SaveStaffsForSynchronization",
  apiPostStaffManagementSynchronizeStaffOlap: "StaffManagement/Staff/SynchronizeStaffOlap",
  apiPostStaffManagementUpdateStaffSequence: "StaffManagement/Staff/UpdateStaffSequence",

  // StaffManagement/StaffingTable
  apiGetStaffManagementGetStaffingTableById: "StaffManagement/StaffingTable/GetStaffingTableById",
  apiGetStaffManagementGetCurrentStaffingTable: "StaffManagement/StaffingTable/GetCurrentStaffingTable",
  apiGetStaffManagementGetDraftStaffingTableById: "StaffManagement/StaffingTable/GetDraftStaffingTableById",
  apiGetStaffManagementGetDraftStaffingTablePostsByStaffingTableId: "StaffManagement/StaffingTable/GetDraftStaffingTablePostsByStaffingTableId",
  apiGetStaffManagementGetDraftStaffingTables: "StaffManagement/StaffingTable/GetDraftStaffingTables",
  apiGetStaffManagementGetStaffingTablePostsByStaffingTableId: "StaffManagement/StaffingTable/GetStaffingTablePostsByStaffingTableId",
  apiGetStaffManagementGetStaffingTables: "StaffManagement/StaffingTable/GetStaffingTables",
  apiGetStaffManagementStaffingTableGetStaffingTablePosts: "StaffManagement/StaffingTable/GetStaffingTablePosts",
  apiPostStaffManagementApproveStaffingTable: "StaffManagement/StaffingTable/ApproveStaffingTable",
  apiPostStaffManagementDeleteProjectStaffingTable: "StaffManagement/StaffingTable/DeleteProjectStaffingTable",
  apiPostStaffManagementCreateDraftStaffingTable: "StaffManagement/StaffingTable/CreateDraftStaffingTable",
  apiPostStaffManagementGetArchiveStaffingTable: "StaffManagement/StaffingTable/GetArchiveStaffingTable",
  apiPostStaffManagementSignCoups: "StaffManagement/StaffingTable/SignCoups",
  apiPostStaffManagementTransitionProjectStaffingTableToProject: "StaffManagement/StaffingTable/TransitionProjectStaffingTableToProject",
  apiPostStaffManagementUpdateDraftStaffingTable: "StaffManagement/StaffingTable/UpdateDraftStaffingTable",

  // StaffManagement/Surcharge
  apiGetStaffManagementGetAllSurcharge: "StaffManagement/Surcharge/GetAllSurcharge",
  apiPostStaffManagementMergeSurcharge: "StaffManagement/Surcharge/MergeSurcharge",

  // StaffManagement/StaffRoles
  apiGetStaffManagementGetAvailableMenus: "StaffManagement/StaffRoles/GetAvailableMenus",
  apiGetStaffManagementGetStaffRoleDepartments: "StaffManagement/StaffRoles/GetStaffRoleDepartments",
  apiPostStaffManagementSaveStaffRoleDepartments: "StaffManagement/StaffRoles/SaveStaffRoleDepartments",
  apiPostStaffManagementSaveStaffStaffRole: "StaffManagement/StaffRoles/SaveStaffStaffRole",

  // StaffManagement/Departments
  apiGetStaffManagementGetCurrentDepartments: "StaffManagement/Departments/GetCurrentDepartments",
  apiGetStaffManagementGetDepartmentBySearchText: "StaffManagement/Departments/GetDepartmentBySearchText",
  apiGetStaffManagementGetDepartmentsByOrganizationStructureId: "StaffManagement/Departments/GetDepartmentsByOrganizationStructureId",
  apiGetStaffManagementGetDepartmentWithFavorites: "StaffManagement/Departments/GetDepartmentWithFavorites",

  // StaffManagement/OrganizationStructure
  apiGetStaffManagementGetCurrentOrganizationStructure: "StaffManagement/OrganizationStructure/GetCurrentOrganizationStructure",
  apiGetStaffManagementGetDraftOrganizationStructure: "StaffManagement/OrganizationStructure/GetDraftOrganizationStructure",
  apiGetStaffManagementGetOrganizationArchives: "StaffManagement/OrganizationStructure/GetOrganizationArchives",
  apiGetStaffManagementGetOrganizationStructures: "StaffManagement/OrganizationStructure/GetOrganizationStructures",
  apiPostStaffManagementApproveOrganizationStructure: "StaffManagement/OrganizationStructure/ApproveOrganizationStructure",
  apiPostStaffManagementDeleteOrganizationStructure: "StaffManagement/OrganizationStructure/DeleteOrganizationStructure",
  apiPostStaffManagementUpdateOrganizationStructure: "StaffManagement/OrganizationStructure/UpdateOrganizationStructure",
  apiPostStaffManagementCreateOrganizationStructure: "StaffManagement/OrganizationStructure/CreateOrganizationStructure",
  apiPostStaffManagementChangeOrganizationStructureProjectStatus: "StaffManagement/OrganizationStructure/ChangeOrganizationStructureProjectStatus",

  // StaffManagement/StaffPersons
  apiGetStaffManagementGetGetVacancies: "StaffManagement/StaffPersons/GetVacancies",
  apiPostStaffManagementFirePerson: "StaffManagement/StaffPersons/FirePerson",
  apiPostStaffManagementCreateDismissalRequestProject: "StaffManagement/StaffPersons/CreateDismissalRequestProject",
  apiPostStaffManagementCreateDocumentForTransferringStaff: "StaffManagement/StaffPersons/CreateDocumentForTransferringStaff",
  apiPostStaffManagementGetStaffProject: "StaffManagement/StaffPersons/GetStaffProject",
  apiPostStaffManagementHirePerson: "StaffManagement/StaffPersons/HirePerson",
  apiPostStaffManagementTransferPerson: "StaffManagement/StaffPersons/TransferPerson",
  apiPostStaffManagementUpdatePersonPosition: "StaffManagement/StaffPersons/UpdatePersonPosition",

  // StaffManagement/Persons
  apiGetStaffManagementGetOutsidePerson: "StaffManagement/Persons/GetOutsidePerson?",
  apiGetStaffManagementGetPerson: "StaffManagement/Persons/GetPerson",
  apiGetStaffManagementGetPersonCertificates: "StaffManagement/Persons/GetPersonCertificates",
  apiGetStaffManagementGetPersonForCandidate: "StaffManagement/Persons/GetPersonForCandidate",
  apiGetStaffManagementGetPersonForUserPage: "StaffManagement/Persons/GetPersonForUserPage",
  apiGetStaffManagementGetPersonnelBase: "StaffManagement/Persons/GetPersonnelBase",
  apiGetStaffManagementGetPersonsForCandidate: "StaffManagement/Persons/GetPersonsForCandidate",
  apiGetStaffManagementGetPersonTranslation: "StaffManagement/Persons/GetPersonTranslation",
  apiGetStaffManagementGetUsers: "StaffManagement/Persons/GetUsers",
  apiPostStaffManagementDeleteCertificate: "StaffManagement/Persons/DeleteCertificate",
  apiPostStaffManagementAddCertificate: "StaffManagement/Persons/AddCertificate",
  apiPostStaffManagementChangePersonInterfaceTheme: "StaffManagement/Persons/ChangePersonInterfaceTheme",
  apiPostStaffManagementCreatePhysicalPerson: "StaffManagement/Persons/CreatePhysicalPerson",
  apiPostStaffManagementDeletePerson: "StaffManagement/Persons/DeletePerson",
  apiPostStaffManagementPutPersonAvatarFile: "StaffManagement/Persons/PutPersonAvatarFile",
  apiPostStaffManagementSavePerson: "StaffManagement/Persons/SavePerson",
  apiPostStaffManagementUpdatePersonsSecrecyLevel: "StaffManagement/Persons/UpdatePersonsSecrecyLevel",
  apiPostStaffManagementUpdatePhysicalPerson: "StaffManagement/Persons/UpdatePhysicalPerson",

  // StaffManagement/OutStaffs
  apiGetStaffManagementGetOutStaffsAsPagination: "StaffManagement/OutStaffs/GetOutStaffsAsPagination",

  // StaffManagement/StaffRelations
  apiGetStaffManagementGetStaffRelation: "StaffManagement/StaffRelations/GetStaffRelation",
  apiGetStaffManagementGetStaffRelations: "StaffManagement/StaffRelations/GetStaffRelations",
  apiPostStaffManagementCreateStaffRelation: "StaffManagement/StaffRelations/CreateStaffRelation",
  apiPostStaffManagementDeleteStaffRelation: "StaffManagement/StaffRelations/DeleteStaffRelation",
  apiPostStaffManagementUpdateStaffRelation: "StaffManagement/StaffRelations/UpdateStaffRelation",
  apiPostStaffManagementGetStaffRelationsByIds: "StaffManagement/StaffRelations/GetStaffRelationsByIds",

  // StaffManagement/Users
  apiGetStaffManagementGetUser: "StaffManagement/Users/GetUser",
  apiGetStaffManagementGetUserInfo: "StaffManagement/Users/GetUserInfo",
  apiGetStaffManagementUpdateUser: "StaffManagement/Users/UpdateUser",
  apiGetStaffManagementUsersGetUsers: "StaffManagement/Users/GetUsers",
  apiPostStaffManagementCreateUser: "StaffManagement/Users/CreateUser",
  apiPostUserDeleteUser: "StaffManagement/Users/DeleteUser",
  apiPostUserDisableLockout: "StaffManagement/Users/DisableLockout",
  apiPostUserEnableLockout: "StaffManagement/Users/EnableLockout",

  // StaffManagement/Contact
  apiPostStaffManagementMergePersonContact: "StaffManagement/Contact/MergePersonContact",
  apiPostStaffManagementSaveCandidates: "StaffManagement/Contact/SaveCandidates",

  // Task/Comments
  apiGetTaskAddComment: "Task/Comments/AddComment",
  apiGetTaskGetComments: "Task/Comments/GetComments",

  // Task/Tasks
  apiGetTaskDeleteTask: "Task/Tasks/DeleteTask",
  apiGetTaskGetArchivedTasks: "Task/Tasks/GetArchivedTasks",
  apiGetTaskGetRelatedTasks: "Task/Tasks/GetRelatedTasks",
  apiGetTaskGetSubTasks: "Task/Tasks/GetSubTasks",
  apiGetTaskGetTask: "Task/Tasks/GetTask",
  apiGetTaskGetTaskFiles: "Task/Tasks/GetTaskFiles",
  apiGetTaskGetTasks: "Task/Tasks/GetTasks",
  apiGetTaskGetTasksAsTable: "Task/Tasks/GetTasksAsTable",
  apiGetTaskPrintArchivedTasks: "Task/Tasks/PrintArchivedTasks",
  apiGetTaskPrintTasks: "Task/Tasks/PrintTasks",
  apiPostTaskAddRelationTask: "Task/Tasks/AddRelationTask",
  apiPostTaskAddTask: "Task/Tasks/AddTask",
  apiPostTaskAddTaskFile: "Task/Tasks/AddTaskFile",
  apiPostTaskAddTaskToArchive: "Task/Tasks/AddTaskToArchive",
  apiPostTaskDeleteRelatedTask: "Task/Tasks/DeleteRelatedTask",
  apiPostTaskDeleteTaskFile: "Task/Tasks/DeleteTaskFile",
  apiPostTaskRestoreTaskFromArchive: "Task/Tasks/RestoreTaskFromArchive",
  apiPostTaskUpdateTask: "Task/Tasks/UpdateTask",
  apiPostTaskUpdateTaskSequence: "Task/Tasks/UpdateTaskSequence",
  apiPostTaskSetTaskMemberAsRead: "Task/Tasks/SetTaskMemberAsRead",

  // Task/Users
  apiGetTaskGetAvatarFile: "Task/Users/GetAvatarFile",
  apiGetUsersGetUsers: "Task/Users/GetUsers",

  // Task/CheckLists
  apiGetTaskGetCheckLists: "Task/CheckLists/GetCheckLists",
  apiPostTaskDeleteCheckList: "Task/CheckLists/DeleteCheckList",
  apiPostTaskCreateCheckList: "Task/CheckLists/CreateCheckList",
  apiPostTaskUpdateCheckList: "Task/CheckLists/UpdateCheckList",

  // Task/Columns
  apiGetTaskGetColumns: "Task/Columns/GetColumns",
  apiPostTaskAddColumn: "Task/Columns/AddColumn",
  apiPostTaskDeleteColumn: "Task/Columns/DeleteColumn",
  apiPostTaskUpdateColumn: "Task/Columns/UpdateColumn",
  apiPostTaskUpdateColumnSequence: "Task/Columns/UpdateColumnSequence",

  // Task/Priorities
  apiGetTaskGetPriorities: "Task/Priorities/GetPriorities",
  apiPostTaskCreatePriority: "Task/Priorities/CreatePriority",
  apiPostTaskDeletePriority: "Task/Priorities/DeletePriority",
  apiPostTaskUpdatePriority: "Task/Priorities/UpdatePriority",
  apiPostTaskUpdatePrioritySequence: "Task/Priorities/UpdatePrioritySequence",

  // Task/Projects
  apiGetTaskGetProjects: "Task/Projects/GetProjects",
  apiPostTaskCreateProject: "Task/Projects/CreateProject",
  apiPostTaskDeleteProject: "Task/Projects/DeleteProject",
  apiPostTaskUpdateProject: "Task/Projects/UpdateProject",
  apiPostTaskUpdateProjectSequence: "Task/Projects/UpdateProjectSequence",

  // Task/CheckListElements
  apiPostTaskCreateCheckListElement: "Task/CheckListElements/CreateCheckListElement",
  apiPostTaskDeleteCheckListElement: "Task/CheckListElements/DeleteCheckListElement",
  apiPostTaskUpdateCheckListElement: "Task/CheckListElements/UpdateCheckListElement",

  // GermesAgent
  apiGetGermesAgentDecryptFileAndDownload: "GermesAgent/DecryptFileAndDownload",
  apiPostAddAccessToFile: "GermesAgent/AddAccessToFile",
  apiPostGermesAgentEncryptFileAndUpload: "GermesAgent/EncryptFileAndUpload",

  // UserSessions
  apiGetStaffGetOnlineUsers: "UserSessions/GetOnlineUsers",

  // UserManagement
  apiGetUserManagementCheckUsernameExists: "/api/UserManagement/CheckUsernameExists",
  apiPostUserManagementChangePassword: "/api/UserManagement/ChangePassword",
  apiPostUserManagementDeleteUser: "/api/UserManagement/DeleteUser",
  apiPostUserManagementDisableLockout: "/api/UserManagement/DisableLockout",
  apiPostUserManagementEnableLockout: "/api/UserManagement/EnableLockout",
  apiPostUserManagementUpdateUserLocalization: "/api/UserManagement/UpdateUserLocalization",
  apiPostUserManagementChangeUserPassword: "/api/UserManagement/ChangeUserPassword",

  // Tokens
  AddInvalidToken: "Tokens/AddInvalidToken",

  /*SignalR hubs url*/
  // O'qilgan deb belgilash hub'dan REST'ga ko'chirildi (hub send ulanish uzilganda jimgina
  // yo'qolardi) — `apiPostNotificationSetNotificationAsRead` / `...SetAllNotificationsAsRead`.
  RemoveNotification: "RemoveNotification",

  /*SignalR connection event names*/
  OnGetNewNotification: "OnGetNewNotification",
  OnNotificationRead: "OnNotificationRead",
  OnNotificationRemove: "OnNotificationRemove",
  OnNotificationsRead: "OnNotificationsRead",
  OnBaikTokenRemoved: "OnBaikTokenRemoved",
};

export default ApiUrl;
